/* eslint-disable @typescript-eslint/no-redeclare */
import { AxiosError } from "axios";
import React from "react";
import { BannerName } from "../misc/banner.type";
import { ICurrentUser } from "../models/user.model";

export interface ServiceOptions<T> {
  loader?: (value: boolean) => void;
  callback?: (data: T) => void;
  handleError?: (error: any) => void;
}

interface MainContext {
  currentUser: ICurrentUser | null;
  loadingCurrentUser: boolean;
  banner: BannerName;
  setBanner: (newBanner: BannerName) => void;
  bannerLink?: string;
  setBannerLink: (bannerLink: string) => void;
  reloadCurrentUser: () => void;
  notify: (
    title: string,
    message: string,
    type: "success" | "error" | "info" | "warning"
  ) => void;
  notifyError: (error: AxiosError | Error) => void;
  service: <T>(
    func: () => Promise<T>,
    options?: ServiceOptions<T>
  ) => Promise<void>;
}

const MainContext = React.createContext<MainContext>({
  currentUser: null,
  loadingCurrentUser: false,
  banner: undefined,
  setBanner: (newBanner: BannerName) => {},
  bannerLink: undefined,
  setBannerLink: (bannerLink: string) => {},
  reloadCurrentUser: () => {},
  notify: (
    title: string,
    message: string,
    type: "success" | "error" | "info" | "warning"
  ) => {},
  notifyError: (error: AxiosError | Error) => {},
  service: <T>(func: () => Promise<T>, options?: ServiceOptions<T>) =>
    Promise.resolve(undefined),
});

export default MainContext;
